import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, CommonModule],
  templateUrl: './message-dialog.component.html',
  styleUrl: './message-dialog.component.css'
})
export class MessageDialogComponent {
  data: any;

  constructor(
    private dialogRef: MatDialogRef<MessageDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) private content: any
  ) {
    this.data = content;
  }

  closeDialog(result: boolean): void {
    this.dialogRef.close(result);
  }
}